module.exports = __webpack_public_path__ + "img/7上缆所传媒.1276bad7.jpg";